import React, { useCallback, useEffect, useState } from 'react'
import { consultarNotificacoes } from '../services/monitoramentoNotificacoes'

const ROTULO = { inativo: 'Offline de dia', falha: 'Falha', atencao: 'Alerta' }
const COR = { inativo: '#64748b', falha: '#dc2626', atencao: '#d97706' }

function hora(iso) {
  if (!iso) return ''
  return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
}

export default function MonitoramentoAlertas({ userEmpresa, onAbrirMonitoramento }) {
  const [alertas, setAlertas] = useState([])
  const [erro, setErro] = useState('')

  const carregar = useCallback(async () => {
    try {
      const dados = await consultarNotificacoes('listar')
      setAlertas(dados.alertas || [])
      setErro('')
    } catch (e) {
      const texto = e.message || 'Não foi possível carregar os avisos.'
      setErro(texto.includes('monitoramento_alertas')
        ? 'Falta criar as tabelas. Rode o SQL das notificações de monitoramento no Supabase.'
        : texto)
    }
  }, [])

  useEffect(() => {
    carregar()
    const id = window.setInterval(carregar, 120000)
    return () => window.clearInterval(id)
  }, [carregar])

  const marcar = async (alertaId) => {
    try {
      await consultarNotificacoes('marcar', { alertaId })
      setAlertas((lista) => lista.map((item) => (item.id === alertaId ? { ...item, lido_em: new Date().toISOString() } : item)))
    } catch (e) {
      setErro(e.message)
    }
  }

  const novos = alertas.filter((item) => !item.lido_em).length

  return (
    <div className="row g-4 mb-4">
      <div className="col-12">
        <div className="card border-0 shadow">
          <div className="card-body">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
              <div>
                <h5 className="mb-1 text-dark">Avisos das usinas</h5>
                <p className="mb-0 text-muted small">
                  Offline só avisa entre 7h e 18h. À noite o desligamento é normal. Falha e alerta avisam a qualquer hora.
                  {userEmpresa?.empresa ? ` · ${userEmpresa.empresa}` : ''}
                </p>
              </div>
              <div className="d-flex align-items-center gap-2">
                {novos > 0 && <span className="badge text-bg-danger">{novos} novo(s)</span>}
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={onAbrirMonitoramento}>
                  Abrir monitoramento
                </button>
              </div>
            </div>
            {erro && <p className="text-danger small mb-0">{erro}</p>}
            {!erro && alertas.length === 0 && (
              <p className="text-muted small mb-0">Nenhuma usina offline de dia, em falha ou em alerta.</p>
            )}
            <div className="d-flex flex-column gap-2">
              {alertas.map((item) => (
                <div
                  key={item.id}
                  className="d-flex flex-wrap justify-content-between align-items-center gap-2 border rounded-3 px-3 py-2"
                  style={{ opacity: item.lido_em ? 0.65 : 1 }}
                >
                  <div>
                    <span className="badge me-2" style={{ background: COR[item.nivel] || '#334155' }}>
                      {ROTULO[item.nivel] || item.nivel}
                    </span>
                    <strong>{item.usina_nome}</strong>
                    <span className="text-muted small ms-2">
                      {item.marca}
                      {item.detalhe ? ` · ${item.detalhe}` : ''} · {hora(item.criado_em)}
                    </span>
                  </div>
                  {!item.lido_em && (
                    <button type="button" className="btn btn-sm btn-light" onClick={() => marcar(item.id)}>
                      Marcar como visto
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
